import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "microphone",
  "use": "microphone-usage",
  "viewBox": "0 0 14 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 19\" id=\"microphone\">\n    <path d=\"M7 0a3 3 0 0 0-3 3v6a3 3 0 1 0 6 0V3a3 3 0 0 0-3-3zM1.088 9c-.606 0-1.094.538-.996 1.137A7 7 0 0 0 6 15.922V18a1 1 0 0 0 2 0v-2.078a7 7 0 0 0 5.908-5.785c.098-.6-.39-1.137-.996-1.137-.494 0-.901.364-.984.852A5.003 5.003 0 0 1 7 14a5.003 5.003 0 0 1-4.928-4.148A1.004 1.004 0 0 0 1.088 9z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol